export default "__VITE_ASSET__0a58e08a__"